<div class="page">
  <div class="container-fluid container-site py-5 text-center">
    <h1 class="display-4">404</h1>
    <p class="lead">La página que buscas no existe o fue movida.</p>
    <a routerLink="/" class="btn btn-outline-dark-custom mt-3"
      >Volver al inicio</a
    >
  </div>
</div>
